import React from "react";
import Marquee from "react-fast-marquee";

const phrases = [
  "शुभ दीपावली",
  "GUARANTEED 2-DAY DELIVERY",
  "प्रीमियम कॉर्पोरेट उपहार",
  "CURATED LUXURY HAMPERS",
  "PAN-INDIA EXPRESS SHIPPING",
];

const EditorialMarquee = () => {
  return (
    <div className="relative z-10 border-y border-[#F3E5AB]/10 bg-[#0B0F19] py-6" data-testid="editorial-marquee">
      <Marquee speed={30} gradient={false} autoFill>
        {phrases.map((p, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-serif text-3xl italic tracking-tight text-[#D4AF37]/40 md:text-5xl">{p}</span>
            <span className="text-2xl text-[#F3E5AB]/50 md:text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
